import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_INPUT } from '../common/interface/request.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(
    private http: HttpClient
  ) { }

  invoke(payload: API_INPUT): Observable<any> {
    let baseUrl = payload.useTradingEngine ? environment.TRADING_ENGINE_URL : environment.ENVIRONEMNT_URL;
    
    // Ensure baseUrl doesn't end with slash if url starts with one, or vice-versa
    if (baseUrl.endsWith('/') && payload.url.startsWith('/')) {
      baseUrl = baseUrl.slice(0, -1);
    } else if (!baseUrl.endsWith('/') && !payload.url.startsWith('/')) {
      baseUrl = baseUrl + '/';
    }

    let url: string = baseUrl + payload.url;
    let obj: any = {}
    if (payload.headers)
      obj["headers"] = payload.headers;
    if (payload.params)
      obj["params"] = payload.params;

    if (payload.method == "GET" || payload.method == "DELETE")
      return this.http.request(payload.method, url, obj);

    obj = { ...obj, body: payload.data };
    return this.http.request(payload.method, url, obj);
  }  

}